module.exports = __webpack_public_path__ + "assets/img/limit_mobile.242acf44.png";